import * as React from 'react';
import PropTypes from 'prop-types';

var propTypes = {
  fill: PropTypes.string,
  height: PropTypes.string,
  width: PropTypes.string
};
var SvgGillyHicksLogotype = function SvgGillyHicksLogotype(_ref) {
  var fill = _ref.fill,
    _ref$height = _ref.height,
    height = _ref$height === void 0 ? null : _ref$height,
    width = _ref.width;
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 361 44",
    fill: fill,
    width: width,
    height: height,
    role: "img"
  }, /*#__PURE__*/React.createElement("title", null, "gilly hicks"), /*#__PURE__*/React.createElement("path", {
    d: "M268.1.2c6.8 0 11.9 2.5 15.5 6.8l-4.3 4.3c-2.6-3.3-6.5-5.1-11-5.1-8.2 0-14.4 5.9-14.4 15.4 0 9.2 6 15.4 14 15.4 4.9 0 8.6-2.1 11.6-5.9l4.4 4c-3.7 5.3-9.6 8-16.2 8-11.3-.1-20.2-8.8-20.2-21.5 0-12.9 9.1-21.4 20.6-21.4ZM21.2.1c6.9 0 12.1 2.5 15.8 7l-4.3 4.3c-2.6-3.3-6.5-5.2-11.2-5.2-7.8 0-14.3 5.8-14.3 15.4 0 9.6 6.3 15.3 14 15.3 7.3 0 11.6-4.2 12.3-11.3H20.2V20h19.9c0 .9.1 1.7.1 2.3 0 12.5-7.6 20.7-19 20.7C10.6 43 .7 35.1.7 21.6.7 8.2 10.2.1 21.2.1Zm325.2.2c5.9 0 10.3 2.3 13.3 5.2l-4.1 4.1c-2.4-2.2-5.4-3.5-9.2-3.5-5.3 0-8.4 2.5-8.4 6.2 0 4.371 4.86 5.296 10.022 6.606l.66.17c5.62 1.464 11.367 3.574 11.418 11.224 0 7.7-5.9 12.6-14.7 12.6-7.1 0-11.9-3-15.2-6.2l4.5-4.1c3.3 2.9 6.9 4.4 10.8 4.4 5.2 0 8.2-2.4 8.2-6.2 0-9.6-22-2.9-22-18.4 0-7 5.9-12.1 14.7-12.1ZM237.5.8v41.6h-6.7V.8h6.7Zm-46.1 0v17.3h19.4V.8h6.7v41.6h-6.7V24.2h-19.4v18.2h-6.7V.8h6.7ZM56.3.8v41.6h-6.7V.8h6.7Zm243.2 0v18h.2l17.4-18h8.4L306.1 20l20.6 22.4h-8.8l-18.3-20.8h-.2v20.8h-6.7V.8h6.8ZM106.7.8v35.3h17.1v6.2H100V.8h6.7ZM76.2.8v35.3h17.1v6.2H69.5V.8h6.7Zm54 .4 10.7 17.2 10.8-17.2h7.8l-15.4 23.1V42h-6.8V24.3L121.7 1.2h8.5Z"
  }));
};
SvgGillyHicksLogotype.propTypes = propTypes;

export { SvgGillyHicksLogotype as default };
//# sourceMappingURL=GillyHicksLogotype.js.map
